export default "<template>\n\n  <KIcon\n    icon=\"helpOutline\"\n    color=\"var(--palette-blue-v600)\"\n  />\n\n</template>\n";